import React from 'react';
import { Navigate, Route } from 'react-router-dom';
import ConversasTerapeuticasLandingPage from '../pages/ConversasTerapeuticas/ConversasTerapeuticasLandingPage';

export const LandingRoutes = (
  <>
    <Route path="/" element={<ConversasTerapeuticasLandingPage />} />
    <Route path="/alunas" element={<Navigate to="/aluna" replace />} />
  </>
);
